/**
 * `/cases/:caseId/hypotheses/:hypothesisId` — one hypothesis (ADR-0095). An id no hypothesis
 * answers to is a legacy research link and opens the research detail instead.
 */
import { ArrowLeft } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Link, Navigate, useParams } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { HypothesisDetail } from '@/features/analytic-hypotheses/HypothesisDetail'
import { useCaseContext } from '../CaseContext'

export default function CaseHypothesisDetailPage() {
  const { t } = useTranslation()
  const { caseId } = useCaseContext()
  const { hypothesisId } = useParams<{ hypothesisId: string }>()
  if (!hypothesisId) return <Navigate to={`/cases/${caseId}/investigations`} replace />
  return (
    <div className="flex min-h-0 flex-1 flex-col overflow-y-auto bg-background">
      <div className="flex w-full flex-col gap-4 px-4 pt-6 pb-8 md:px-8">
        <div>
          <Button asChild variant="ghost" size="sm" className="-ml-2">
            <Link to={`/cases/${caseId}/investigations`}>
              <ArrowLeft className="size-3.5" />
              {t('analyticHypotheses.detail.back')}
            </Link>
          </Button>
        </div>
        <HypothesisDetail caseId={caseId} hypothesisId={hypothesisId} />
      </div>
    </div>
  )
}
